var shared_data = {
    list: [],
    idx_by_id: function(id) {
        return this.list.findIndex(obi => obi.id == id)
    },
    defi_by_id: function(id) {
        return this.list[this.idx_by_id(id)]
    },
}
export default shared_data
